import Hamburger from './Hamburger'

export default Hamburger
// eslint-disable-next-line import/export
export * from './Hamburger'
